import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

export default class BusinessInvalidAddressController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
}
